import { Button, NotFoundContainer } from '@/components/ui';
import { useGetProfessionalUnavailability } from '@/services/queries/professional-unavailability';
import { ListFilterPlus, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { UnavailabilityCard } from './components';
import { useEffect, useState } from 'react';
import { DataTablePagination } from '@/components/data-table/Pagination';
import DateRangePicker from '@/components/ui/DateRangePicker';

const Unavailabilities = () => {
	const navigate = useNavigate();
	const [page, setPage] = useState(1);
	const [endDateFilter, setEndDateFilter] = useState<string | null>(null);
	const [filterByDate, setFilterByDate] = useState(false);
	const [clearDateFilter, setClearDateFilter] = useState(false);
	const [startDateFilter, setStartDateFilter] = useState<string | null>(null);
	const limit = 8;

	const { data, isSuccess } = useGetProfessionalUnavailability({
		...(filterByDate &&
			startDateFilter &&
			endDateFilter && {
				date_a: startDateFilter,
				date_b: endDateFilter,
			}),
		limit,
		page,
	});

	useEffect(() => {
		if (isSuccess) {
			setClearDateFilter(true);
		}
	}, [isSuccess]);

	const handleDateChange = (startDate: Date | null, endDate: Date | null) => {
		const startISO = startDate ? startDate.toISOString() : null;
		const endISO = endDate ? endDate.toISOString() : null;
		setPage(1);
		if (startISO) setStartDateFilter(startISO);
		if (endISO) setEndDateFilter(endISO);
		if (startISO && endISO) {
			setFilterByDate(true);
		} else {
			setFilterByDate(false);
		}
	};

	const handlePageChange = (newPage: number) => setPage(newPage);

	return (
		<div className="h-full w-full space-y-6">
			<div className="flex w-full items-center justify-between gap-2">
				<h2 className="whitespace-nowrap text-lg font-medium text-dark">
					Indispobilidade
				</h2>

				<Button
					text="Criar indisponibilidade"
					className="h-fit w-fit justify-center rounded-full bg-black px-6 py-2 text-sm font-bold shadow-md hover:bg-neutral-800 md:text-base"
					startIcon={
						<Plus className="size-5 stroke-[3] text-white" />
					}
					onClick={() =>
						navigate(
							'/profissional/horarios/indisponibilidade/criar',
						)
					}
				/>
			</div>
			<div className="flex w-full flex-col gap-2 text-sm text-zinc-500 md:w-fit">
				<div className="flex items-end gap-2">
					<ListFilterPlus className="size-3.5" />
					<span className="whitespace-nowrap leading-3">
						Filtrar por data
					</span>
				</div>
				<div className="flex">
					<DateRangePicker
						onChange={handleDateChange}
						clearable={clearDateFilter}
					/>
				</div>
			</div>
			{data && data.data.length > 0 ? (
				<div className="flex flex-wrap gap-4">
					{data.data.map((unavailability, index) => (
						<UnavailabilityCard key={index} {...unavailability} />
					))}
				</div>
			) : (
				<NotFoundContainer
					className="mx-auto mt-10 lg:!mt-32"
					title="Nenhum resultado encontrado"
					message={
						<div className="flex justify-center gap-1">
							<Button
								onClick={() =>
									navigate(
										'/profissional/horarios/indisponibilidade/criar',
									)
								}
								className="rounded-none border-0 !border-b border-solid border-blue-500 px-0 py-0 !leading-3 text-blue-500"
								text="Criar"
								variant="text"
							/>
							<span>data de indisponibilidade</span>
						</div>
					}
				/>
			)}
			{data && data.total > limit && (
				<DataTablePagination
					onPageChange={handlePageChange}
					page={page}
					totalItems={data.total}
					pageSize={limit}
				/>
			)}
		</div>
	);
};

export { Unavailabilities };
